import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import env from '../env';

const galleryApi = createApi({
    reducerPath: 'gallery',
    baseQuery: fetchBaseQuery({
        baseUrl: env.baseUrl,
        prepareHeaders: (headers, { getState }) => {

            const token = getState().environment.token;

            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }

            return headers
        }
    }),
    tagTypes: ['Gallery'],
    endpoints(builder) {
        return {
            getGallery: builder.query({
                query: () => {
                    return {
                        url: `/gallery`,
                        method: 'GET',
                    };
                },
                providesTags: (_) => [{ type: 'Gallery' }]

            }),
            savePhoto: builder.mutation({
                query(data) {

                    return {
                        url: `/gallery/${data.id}`,
                        method: 'PUT',
                        body: data
                    }
                },
                invalidatesTags: (_result, _error, _) => [{ type: 'Gallery' }],
            }),
            deletePhoto: builder.mutation({
                query(data) {

                    return {
                        url: `/gallery/${data.id}`,
                        method: 'DELETE'
                    }
                },
                invalidatesTags: (_result, _error, _) => [{ type: 'Gallery' }],
            })
        };
    }
});

export const {
    useGetGalleryQuery,
    useSavePhotoMutation,
    useDeletePhotoMutation
} = galleryApi;
export { galleryApi };
